export class Utilisateur {
  id: any;
  nom: any;
  prenom: any;
  email: any;
  password: any;
  confirmPassword: any;
  telephone: any;
  numero: any;
  rue: any;
  ville: any;
  pays: any;
  codePostal: any;
  compagnie: any;

}
